import React from 'react';
import { Button } from 'antd'
import './peekPasswordButton.css';

export const PeekPasswordButton = ({passwordType, onClick}) => (
  <Button icon={passwordType === 'input' ? "eye-o" : "eye"}
          onClick={onClick}
          className={passwordType === 'input' ?
                    "peek-password-button peek-password-button_active" :
                    "peek-password-button peek-password-button_inactive"}/>
);



// WEBPACK FOOTER //
// ./src/components/common/peekPasswordButton/peekPasswordButton.js